import React from "react";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import { DownloadCardSection } from "@/.storyblok/types/319751/storyblok-components";
import Image from "next/image";
interface DownloadCardIndustryReportsProps {
  blok?: DownloadCardSection & SbBlokData;
}

const DownloadCardIndustryReports: React.FC<DownloadCardIndustryReportsProps> = ({ blok }) => {
  if (!blok) return null;

  const { type, items_manual, title, description } = blok;

  const renderCard = (item: any) => {
    const isInfographic = type === 'infographic';

    return (
      <div className={`col mb-3 ${isInfographic ? 'text-center' : ''}`}>
        <div className={`card card-lighter overflow-hidden h-100 ${!isInfographic ? 'flex-xl-row' : ''}`}>
          {item.image?.filename && (
            <Image
              src={item.image.filename}
              alt={item.title}
              width={0}
              height={0}
              style={{ width: '100%', height: 'auto' }}
              className="img-fluid mx-auto component-cards-content-image"
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              loading="lazy"
              quality={75}
            />
          )}
          <div className="p-4">
            <h3 className="mt-2">{item.title}</h3>
            <p className="lead mb-0">{item.subtitle}</p>
            <p className="mt-4 mb-0">
              <a
                href={item.cta_button_link?.cached_url || ""}
                className="btn btn-primary"
                target="_blank"
              >
                {item.cta_button || (isInfographic ? 'Download now' : 'Read more')}
              </a>
            </p>
          </div>
        </div>
      </div>
    );
  };

  const getGridCols = () => {
    switch (type) {
      case 'infographic':
        return 'row-cols-lg-3';
      case 'case_study':
      case 'previous':
        return 'row-cols-lg-2';
      default:
        return 'row-cols-lg-1';
    }
  };

  const bgClass = type === 'featured' ? 'bg-light' : 'bg-white';

  return (
    <div className={`${bgClass} component-cards-content py-4 py-md-5`} {...storyblokEditable(blok)}>
      <div className="container">
        <h2 className="col-24 text-center mb-5">{title || ''}</h2>
        {description && type !== 'infographic' && (
          <p className="lead mb-5 text-center max-two-thirds">{description}</p>
        )}
      </div>
      <div className={`container row row-cols-1 ${getGridCols()} justify-content-center g-lg-4 mx-auto`}>
        {items_manual?.map((item, index) => (
          <React.Fragment key={item._uid || index}>
            {renderCard(item)}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default DownloadCardIndustryReports;